import { getServerSidePropsForProfile, V4ProfilePublicPageLayoutContainer } from "../../../../pagelayouts/profile/V4ProfilePublicPageLayoutContainer";

export default function ProfileSmartShareStandalonePublicPage() {
    return <V4ProfilePublicPageLayoutContainer isSmartPage />;
}

export const getServerSideProps = getServerSidePropsForProfile(true);
